module.exports = __webpack_public_path__ + "img/icon-edit-table.0c60cefd.svg";